export const imaging = {
  'imaging.title': 'Imaging',
  'imaging.subtitle': 'Hosted CT and MRI studies available to this patient’s care team.',
  'imaging.tableLabel': 'Patient imaging studies',
  'imaging.add': 'Add imaging study',
  'imaging.folder': 'Folder',
  'imaging.folderUnfiled': 'No folder',
  'imaging.forbidden': 'Imaging studies are not available to this account',
  'imaging.forbiddenDetail': 'Your clinic has not granted access to hosted imaging.',
  /* The superseded section, for an account the menu no longer offers it to.
     It says where the studies went rather than that they are missing — they
     are in the chart's files, as Medical images. */
  'imaging.movedTitle': 'Imaging is part of the patient’s files',
  'imaging.movedDetail': 'Studies and imports are rows of the Files table. Filter its Content column by “Medical images” to see them on their own.',
  'imaging.loading': 'Loading imaging studies…',
  'imaging.loadFailed': 'Imaging studies could not be loaded.',
  'imaging.retry': 'Try again',
  'imaging.empty': 'No hosted imaging studies',
  'imaging.emptyDetail': 'Validated CT and MRI studies imported for this patient will appear here.',
  'imaging.noMatches': 'No imaging study matches the current filters',
  'imaging.columnStudy': 'Study',
  'imaging.columnDate': 'Study date',
  'imaging.columnModality': 'Type',
  'imaging.columnSeries': 'Series',
  'imaging.columnImages': 'Images',
  'imaging.columnSource': 'Source',
  'imaging.columnStatus': 'Status',
  'imaging.columnActions': 'Actions',
  'imaging.studyUntitled': 'Imaging study',
  'imaging.viewerOpen': 'Open viewer',
  'imaging.viewerOpenNamed': 'Open viewer for {name}',
  'imaging.viewerOpening': 'Opening viewer…',
  'imaging.viewerUnavailable': 'The viewer could not be opened. Try again.',
  'imaging.viewerContinue': 'Continue to viewer',
  'imaging.viewerPopupBlocked': 'The browser blocked the new viewer tab. Continue with this link.',
  'imaging.viewerPending': 'Archive verification pending',
  /* A study Core has recorded as entered in error. It stays in the chart as a
     row with no viewer, because the fact that it was recorded and withdrawn is
     itself part of the record. */
  'imaging.statusWithdrawn': 'Withdrawn — entered in error',

  /* THE STUDY'S OWN PROPERTIES PANEL, opened from the merged registry the way
     a document's is. Storage sits behind a fold: retention and the DICOM
     identifier are what an administrator answers a support question with,
     never what a clinician reads first. */
  'imaging.studyPanelTitle': 'Imaging study properties',
  'imaging.studyStorage': 'Storage and retention',
  'imaging.studyRetention': 'Retention policy',
  'imaging.retentionIndefinite': 'Kept until deleted',
  'imaging.retentionUntil': 'Kept until {date}',
  'imaging.studyRegistered': 'Registered',
  'imaging.studyIdentifier': 'Study instance UID',
  'imaging.purgeLabel': 'Deletion',
  'imaging.purge.queued': 'Queued for permanent deletion',
  'imaging.purge.purged': 'Permanently deleted',
  'imaging.purge.failed': 'Permanent deletion failed',

  /* THIS CLINIC'S OWN WORDS ABOUT THE STUDY, beside the archive's evidence
     rather than over it. The title and the comment are the only two things the
     metadata write accepts; every DICOM field above them is read-only fact. */
  'imaging.studyComment': 'Comment',
  'imaging.noComment': 'No comment recorded',
  'imaging.editMetadata': 'Edit details',
  'imaging.editFormLabel': 'Edit details for {name}',
  'imaging.editTitle': 'Title',
  // Says what a cleared title falls back to, so clearing it reads as a choice
  // rather than as deleting the study's name.
  'imaging.editTitleHint': 'Leave empty to go by the description the archive supplied.',
  'imaging.editComment': 'Comment',
  'imaging.editSave': 'Save details',
  'imaging.editSaving': 'Saving',
  'imaging.editCancel': 'Cancel',
  'imaging.editStaleRevision': 'Someone else changed these details while you were editing.',
  'imaging.editStaleRevisionDetail':
    'Load the saved revision to see what is stored now, then apply your change to it.',
  'imaging.editReload': 'Load the saved revision',
  // Says plainly that nothing was lost: a failed recovery must not read as a
  // second failure that also took the typed text with it.
  'imaging.editReloadFailed': 'The saved revision could not be loaded. Your changes are still here.',
  'imaging.editInvalid': 'Check the details and try again.',
  'imaging.editForbidden': 'You do not have permission to edit this study.',
  'imaging.editGone': 'This study is no longer available.',
  'imaging.editSessionEnded': 'Your session ended. Sign in again to continue.',
  'imaging.editUnavailable': 'The details could not be saved right now. Try again later.',
  'imaging.editUnsavedTitle': 'Unsaved details',
  'imaging.editUnsavedDetail': 'You have changed the details of this study and not saved them.',
  'imaging.editKeepEditing': 'Keep editing',
  'imaging.editDiscard': 'Discard changes',
  /* What the navigation guard NAMES the unsaved work, so a clinician leaving
     the chart is told which form is holding it. */
  'imaging.unsavedIntent': 'Imaging study details',

  /* WHICH RECORDS THE STUDY IS FILED AGAINST. The words are the imaging
     surface's own; the block they fill is the one the document panel uses. */
  /* WHAT A LINK OFF THE LOADED PAGES IS CALLED. A study's link carries no
     definition code of its own, so a Record the candidate list has not reached
     is named by the generic word beside the instant it was filed — never by a
     guess at what kind of note it is. */
  'imaging.linkUnknownRecord': 'Record',
  'imaging.linksTitle': 'EMR entries',
  'imaging.linksNone': 'No EMR entries are linked to this study.',
  'imaging.linksAdd': 'Add an EMR entry',
  'imaging.linkPick': 'Link to a record…',
  // A FAILED READ, never an absence: the panel cannot claim a study is filed
  // against nothing when it could not ask.
  'imaging.linksUnavailable': 'The record links for this study are unavailable.',
  'imaging.linkedAt': 'Linked {date}',
  'imaging.unlinkAction': 'Unlink',
  'imaging.unlinkRecord': 'Unlink {name}',
  'imaging.linkWorking': 'Working',
  'imaging.linkAddTitle': 'Link to a record',
  'imaging.linkRecordsLoading': 'Loading records',
  'imaging.linkRecordsUnavailable': 'The record list is unavailable',
  'imaging.linkNoneOnThisPage': 'No further records on this page. Show older records to find more.',
  'imaging.linkNoneAvailable': 'This patient has no other final records to link.',
  'imaging.linkAction': 'Link',
  'imaging.linkRecord': 'Link to {name}',
  'imaging.recordFinalizedAt': 'Finalized',
  'imaging.recordStatusFinal': 'Final',
  'imaging.linkMoreRecords': 'Show older records',
  'imaging.linkForbidden': 'You do not have permission to change record links for this study.',
  'imaging.linkGone':
    'That link could not be changed. The study or the record is no longer available.',
  'imaging.linkUnavailable': 'The record link could not be changed right now. Try again later.',

  'imaging.exportReadingInventory': 'Reading study metadata',
  'imaging.exportReadingSources': 'Reading selected source objects',
  'imaging.exportRendering': 'Encoding DICOM objects',
  'imaging.exportPackaging': 'Preparing the ZIP archive and media index',
  'imaging.exportUploading': 'Saving the export archive',
  'imaging.exportMetadataCount': 'Metadata read in this series: {count} objects',
  'imaging.exportObjectCount': 'DICOM objects prepared: {count}',
  'imaging.exportCancelPreparationHint': 'Cancelling after the server finishes validating the selection. The export will not remain queued.',
  'imaging.exportTitle': 'Export DICOM study',
  'imaging.exportSubtitle': 'Choose the exact series, frame ranges, crop and encoding required by the receiving offline viewer.',
  'imaging.exportLoading': 'Reading series and frame inventory…',
  'imaging.exportInventoryFailed': 'The export inventory could not be read. Close the panel and try again.',
  'imaging.exportForbidden': 'You do not have permission to export this imaging study.',
  'imaging.exportStudyUnavailable': 'This imaging study is no longer available for export.',
  'imaging.exportSourceChanged': 'The study changed after these options were loaded. Close the panel and open Export again.',
  'imaging.exportEmpty': 'This study has no supported CT or MR image series to export.',
  'imaging.exportFormat': 'Output format',
  'imaging.exportTransferSyntax': 'Transfer Syntax',
  'imaging.exportTransferSyntaxHint': 'Choose the encoding supported by the receiving physician’s offline viewer.',
  'imaging.exportLossyQuality': 'JPEG quality (1–100)',
  'imaging.exportLayout': 'DICOM object layout',
  'imaging.exportLayoutSource': 'Keep source layout',
  'imaging.exportLayoutClassic': 'Classic — one instance per frame',
  'imaging.exportLayoutEnhanced': 'Enhanced — multi-frame',
  'imaging.exportDicomdir': 'Include DICOMDIR media index',
  'imaging.exportSeries': 'Series and frames',
  'imaging.exportSeriesSelected': 'Selected: {count}',
  'imaging.exportSelectAll': 'Select all',
  'imaging.exportSelectNone': 'Select none',
  'imaging.exportSeriesFacts': '{modality} · {count} ordered positions',
  'imaging.exportSourceObjects': 'Source objects',
  'imaging.exportPixelMatrix': 'Pixel matrix',
  // The matrix, the step and the stack dimension are VALUES, and each of
  // them used to be welded together in TSX: `{rows} × {columns}`, a `mm`
  // suffix and a `label: value` pair. Word order, the multiplication sign
  // and where a unit stands are the translator's, so they are written here.
  'imaging.exportPixelMatrixValue': '{rows} × {columns}',
  'imaging.exportStoredLayout': 'Stored layout',
  'imaging.exportSourceClassic': 'Classic instances',
  'imaging.exportSourceMultiframe': 'Multi-frame instance',
  'imaging.exportSourceState': 'Source state',
  'imaging.exportSourceOriginal': 'Original',
  'imaging.exportSourceDerived': 'Already derived',
  'imaging.exportSpacing': 'Plane spacing',
  'imaging.exportSpacingRegular': 'Regular',
  'imaging.exportSpacingIrregular': 'Irregular',
  'imaging.exportSpacingUnknown': 'Unknown',
  'imaging.exportInterPlaneStep': 'Inter-plane step',
  'imaging.exportMillimetres': '{value} mm',
  'imaging.exportSopClasses': 'SOP Classes',
  'imaging.exportStoredSyntaxes': 'Stored Transfer Syntaxes',
  'imaging.exportStack': 'Spatial stack',
  'imaging.exportStackOption': '{id} · {count} positions',
  'imaging.exportStackDimension': '{label}: {value}',
  'imaging.exportDimensionStack': 'Stack',
  'imaging.exportDimensionTemporal': 'Temporal position',
  'imaging.exportDimensionEchoNumber': 'Echo number',
  'imaging.exportDimensionEchoTime': 'Echo time',
  'imaging.exportDimensionDiffusionBValue': 'Diffusion b-value',
  'imaging.exportSelection': 'Position selection',
  'imaging.exportSelectionRange': 'Range and step',
  'imaging.exportSelectionExact': 'Exact positions',
  'imaging.exportFirst': 'First',
  'imaging.exportLast': 'Last',
  'imaging.exportStep': 'Step',
  'imaging.exportRangeHint': 'Inclusive one-based range in patient-space stack order; Step 2 takes every other position.',
  'imaging.exportExactPositions': 'Positions',
  'imaging.exportExactPositionsPlaceholder': '451, 453, 457',
  'imaging.exportExactPositionsHint': 'Enter increasing one-based positions separated by commas or spaces (1–{count}).',
  'imaging.exportRangeUnavailable': 'Patient-space order is unavailable, so this series can only be exported in full.',
  'imaging.exportCrop': 'Spatial crop',
  'imaging.exportCropNone': 'No crop',
  'imaging.exportCropPixel': 'Pixel rectangle',
  'imaging.exportCropPatient': 'Patient-space box (mm)',
  'imaging.exportLeft': 'Left',
  'imaging.exportTop': 'Top',
  'imaging.exportWidth': 'Width',
  'imaging.exportHeight': 'Height',
  // The axis letter is part of the phrase rather than a prefix glued on in
  // TSX: Hebrew names the bound first and the axis after it.
  'imaging.exportAxisMinimum': '{axis} minimum',
  'imaging.exportAxisMaximum': '{axis} maximum',
  'imaging.exportSegmentationRoi': 'Segmentation ROI',
  'imaging.exportSegmentationNone': 'Do not apply a segmentation',
  'imaging.exportSegmentationOption': '{number} · {name}',
  'imaging.exportSegmentationMode': 'Segmentation mask',
  'imaging.exportSegmentationInclude': 'Keep pixels inside the segmentation',
  'imaging.exportSegmentationExclude': 'Remove pixels inside the segmentation',
  'imaging.exportInvalid': 'Select at least one series and check every selection and crop value.',
  'imaging.exportSelectionInvalid': 'Select a series and a valid spatial stack. Check the selected positions against the available position count.',
  'imaging.exportRangeInvalid': 'First, Last and Step must be positive whole numbers. First must not exceed Last, and Last must be within the available positions.',
  'imaging.exportExactInvalid': 'Enter available position numbers in increasing order, without duplicates, separated by spaces or commas.',
  'imaging.exportPixelInvalid': 'The pixel crop must fit inside the image matrix. Use nonnegative whole numbers for Left and Top and positive whole numbers for Width and Height.',
  'imaging.exportPatientInvalid': 'Enter all six patient-space coordinates in millimetres. Each minimum must be smaller than its maximum.',
  'imaging.exportQualityInvalid': 'JPEG Baseline quality must be a whole number from 1 to 100. Other encodings do not use this setting.',
  'imaging.exportDicomdirFailed': 'The DICOMDIR media index could not be created from these image headers. Turn off “Include DICOMDIR media index” and export again. If the receiving viewer requires DICOMDIR, ask support to check the source metadata.',
  'imaging.exportCropEmpty': 'The crop is invalid or does not intersect the selected images. Check its bounds; for a patient-space box, select the full position range so the box can choose the frames.',
  'imaging.exportEncodingFailed': 'The selected encoding cannot represent these pixels or this transformation. Choose Uncompressed — Explicit VR Little Endian and try again.',
  'imaging.exportDecodeFailed': 'The source pixels could not be decoded. Try exporting the complete source objects as stored, or ask support to check the source file.',
  'imaging.exportGeometryFailed': 'The source lacks reliable patient-space geometry for this operation. Export the whole series in source layout without a crop or segmentation mask.',
  'imaging.exportLayoutFailed': 'The selected object layout is incompatible with these images. Keep source layout, choose Uncompressed — Explicit VR Little Endian, or export incompatible series separately.',
  'imaging.exportSegmentationFailed': 'The segmentation does not align with the selected images. Remove the segmentation mask or select one from the same frame of reference.',
  'imaging.exportMediaFailed': 'The generated package failed its integrity check. Create the export again; if it fails again, ask support to check the source file. No source images were changed.',
  'imaging.exportAsStoredUnavailable': 'As stored is unavailable when changing layout, extracting part of a multi-frame object, cropping or masking. A generated encoding is used instead.',
  'imaging.exportJpegUnavailable': 'JPEG Baseline is unavailable for these pixels: it requires unsigned 8-bit images. Use an available lossless encoding to preserve the source pixel values.',
  'imaging.exportPatientCropHint': 'Coordinates are in patient space. Keep the full position range to let the box select the frames. Export positions follow patient-space order and may differ from frame numbers shown by a viewer.',
  'imaging.exportAction': 'Export',
  'imaging.exportStarting': 'Starting export…',
  'imaging.exportQueued': 'Export queued',
  'imaging.exportRunning': 'Creating DICOM package',
  'imaging.exportRunningHint': 'The server is generating and validating the selected objects. This panel may be closed safely.',
  'imaging.exportCancel': 'Cancel export',
  'imaging.exportCancelling': 'Cancelling…',
  'imaging.exportReady': 'The temporary DICOM package is ready to download.',
  'imaging.exportDownload': 'Download export',
  'imaging.exportFailed': 'The DICOM package could not be generated. Try again with Uncompressed — Explicit VR Little Endian; if it still fails, ask support to check the export. No source images were changed.',
  'imaging.exportCancelled': 'The export was cancelled and temporary data is being removed.',
  'imaging.exportExpired': 'This temporary export has expired. Create it again from the study.',
  'imaging.exportStatusFailed': 'Export status could not be refreshed. The server-side job is unchanged.',
  'imaging.exportCreateFailed': 'The export could not be started. Check the parameters and try again.',
  'imaging.exportCancelFailed': 'The export could not be cancelled. Its current server state is unchanged.',
  'imaging.exportTsAsStored': 'As stored — no transcoding',
  'imaging.exportTsImplicit': 'Uncompressed — Implicit VR Little Endian',
  'imaging.exportTsExplicit': 'Uncompressed — Explicit VR Little Endian',
  'imaging.exportTsJpegBaseline': 'JPEG Baseline — lossy 8-bit',
  'imaging.exportTsJpegLossless': 'JPEG Lossless SV1',
  'imaging.exportTsJpegLs': 'JPEG-LS Lossless',
  'imaging.exportTsJpeg2000': 'JPEG 2000 Lossless',
  'imaging.exportTsRle': 'RLE Lossless',

  'imaging.importTitle': 'Add imaging study',
  'imaging.importSubtitle': 'Choose where the study comes from. Its row appears in the table straight away, and Terysling validates the source before anything becomes available in the patient chart.',
  'imaging.sourceLegend': 'Imaging source',
  'imaging.sourceArchive': 'Upload archives',
  'imaging.sourceArchiveDetail': 'ZIP packages supplied by the patient or imaging centre. Choose several and each one is imported on its own.',
  'imaging.sourceFiles': 'Choose folder or files',
  'imaging.sourceFilesDetail': 'Copied medical-media contents, imported as one source; bundled viewer programs are ignored.',
  'imaging.sourceRemote': 'Import from link',
  'imaging.sourceRemoteDetail': 'Terysling downloads an importable imaging package over HTTPS.',
  'imaging.kindArchive': 'ZIP archive',
  'imaging.kindFiles': 'Folder or files',
  'imaging.kindRemote': 'Download link',
  'imaging.chooseArchive': 'Choose ZIP archives',
  'imaging.chooseMoreArchives': 'Add more archives',
  'imaging.chooseFolder': 'Choose folder',
  'imaging.chooseFiles': 'Choose files',
  'imaging.chosenOne': '1 file selected',
  'imaging.chosenMany': '{count} files selected',
  'imaging.chosenBytes': '{size} total',
  'imaging.chosenMore': 'Not listed above: {count}',
  'imaging.removeChosen': 'Remove {name}',
  'imaging.fileSetLabel': 'Selected files',
  'imaging.invalidArchive': 'Choose non-empty ZIP archives within the supported size limits.',
  'imaging.invalidFiles': 'Choose between 1 and 100,000 non-empty files within the supported size limits.',
  'imaging.remoteUrl': 'Download link',
  'imaging.remoteUrlPlaceholder': 'https://imaging-centre.example/download',
  'imaging.remotePassword': 'Password or access code (optional)',
  'imaging.remotePasswordHint': 'The secret is sent once for this import and is not shown again.',
  'imaging.invalidRemoteUrl': 'Enter a valid HTTPS link without a username or password in the URL.',
  'imaging.startImportOne': 'Start import',
  'imaging.startImportMany': 'Start imports: {count}',

  'imaging.phase.starting': 'Starting…',
  'imaging.phase.transferring': 'Transferring',
  'imaging.phase.checking': 'Validating',
  'imaging.phase.review': 'Ready to save',
  'imaging.phase.saving': 'Saving',
  'imaging.phase.interrupted': 'Transfer interrupted',
  'imaging.phase.refused': 'Import refused',
  'imaging.transportProgress': '{percent}% transferred',
  'imaging.transportRetry': 'Resume upload',
  'imaging.transportRetryNamed': 'Resume the upload of {name}',
  'imaging.transportRetrying': 'Resuming…',
  'imaging.reselectSource': 'Reselect source',
  'imaging.reselectSourceNamed': 'Reselect the original source for {name}',
  'imaging.restartImport': 'Start again',
  'imaging.restartImportNamed': 'Start the import of {name} again',
  /* STARTING A REFUSED DOWNLOAD OVER. Core holds the address and did the
     downloading, so there is nothing here to resume: the second attempt is a
     new import and the refused one is cancelled. The password is asked for
     again because it was never kept in this browser. */
  'imaging.restartRemoteTitle': 'Download this source again?',
  'imaging.restartRemoteDetail': 'Terysling keeps the address, not the download, so this starts a new import from the same address and cancels the refused one. The password is asked for again because it was handed over once and is not kept in this browser.',
  'imaging.restartRemoteKeep': 'Keep the refused import',
  'imaging.importRefreshFailed': 'Import status could not be refreshed. The import is still retained by Terysling.',
  'imaging.uploadLedgerFailed': 'The upload list could not be refreshed. Existing rows remain visible.',
  'imaging.saveStudy': 'Save study',
  'imaging.saveStudyNamed': 'Save {name}',
  /* CANCELLING A TRANSFER THIS BROWSER CARRIES, from the glyph beside its bar. */
  'imaging.cancelUploadNamed': 'Cancel the upload of {name}',
  'imaging.cancelUploadTitle': 'Cancel this upload?',
  'imaging.cancelUploadDetail': 'The upload stops, its authority is revoked, reserved space is released and staged bytes are queued for deletion. The row then leaves every upload list.',
  'imaging.cancelUploadKeep': 'Keep uploading',
  'imaging.cancelUploadConfirm': 'Cancel upload',
  'imaging.cancelUploadFailed': 'The upload could not be cancelled. It remains visible and no work was hidden.',
  'imaging.uploadsUnfinished': 'Unfinished uploads: {continuing} continuing, {paused} awaiting source reselection, {confirmation} awaiting confirmation, {refused} refused.',
  'imaging.uploadsUnfinishedDismiss': 'Dismiss',

  'imaging.detectedCountOne': '1 study detected',
  'imaging.detectedCountMany': '{count} studies detected',
  'imaging.previewTitle': 'Review detected studies',
  'imaging.previewDetail': 'DICOM identity below is source evidence only. It never changes the selected Terysling patient.',
  'imaging.targetPatient': 'Target Terysling patient',
  'imaging.sourcePatient': 'Patient details in DICOM',
  'imaging.identityComparison': 'Patient identity comparison',
  'imaging.patientName': 'Name',
  'imaging.patientId': 'Patient ID',
  'imaging.patientBirthDate': 'Birth date',
  'imaging.patientSex': 'Sex',
  'imaging.notRecorded': 'Not recorded',
  'imaging.studySelect': 'Import {name}',
  'imaging.studyDescription': 'Description',
  'imaging.studyBodyPart': 'Body area',
  'imaging.studySource': 'Source organization',
  'imaging.studyDate': 'Study date',
  'imaging.studySeries': 'Series',
  'imaging.studyImages': 'Images',
  'imaging.demographicMismatchTitle': 'Patient details do not match',
  'imaging.demographicMismatchDetail': 'Check both identities carefully. Import only when this study belongs to the selected patient.',
  'imaging.demographicMismatchConfirm': 'I verified that the selected studies belong to this patient',
  'imaging.confirm': 'Save selected studies',
  'imaging.confirming': 'Saving…',
  'imaging.confirmSelectionRequired': 'Select at least one supported study.',
  'imaging.confirmMismatchRequired': 'Verify the patient mismatch before importing.',
  'imaging.confirmFailed': 'The import could not be confirmed. The preview has been refreshed — check it and try again.',
  /* EACH REFUSAL, AND THE DIFFERENT ACT IT ASKS FOR. The confirm re-reads the
     import after any refusal, so every one of these describes a preview that
     has just been refreshed rather than asking for a refresh nothing performs. */
  'imaging.confirmStale': 'The preview moved on while this was open and has just been refreshed. Check what is selected now, then save again.',
  'imaging.confirmNotConfirmable': 'This import is no longer awaiting confirmation — it has already been saved, cancelled or refused. The refreshed preview says which.',
  'imaging.confirmSelectionRefused': 'The selected studies were refused. The preview has been refreshed; select from the studies it lists now.',
  'imaging.confirmQuota': 'Saving these studies would exceed the clinic’s imaging storage. Save fewer studies, or free space first.',
  'imaging.confirmMismatchRefused': 'A patient mismatch this preview did not show is on the import. It has been refreshed — read the comparison again and confirm the mismatch.',
  'imaging.confirmForbidden': 'This account may not save imaging studies. Nothing was saved.',
  'imaging.confirmGone': 'This import is no longer available. Nothing was saved.',
  'imaging.confirmUnavailable': 'Imaging storage did not answer. Nothing was saved, and this is worth trying again.',
  'imaging.dicomUidCollision': 'This study is already assigned to patient {displayName} ({patientCode}).',

  'imaging.deleteSelected': 'Delete selected: {count}',
  'imaging.aiUnavailableForStudies':
    'AI tools cannot read imaging studies yet. A run covers the selected documents only.',
  'imaging.deleteTitle': 'Delete the selected imaging?',
  'imaging.deleteStudiesTitle': 'Hosted studies, deleted for good',
  'imaging.deleteStudiesDetail': 'Viewer access is revoked and the archive is queued for permanent deletion. This cannot be undone.',
  'imaging.deleteQueuedTitle': 'Imports in progress, cancelled everywhere',
  'imaging.deleteQueuedDetail': 'Their transfers and processing stop, upload authority is revoked, reserved space is released and staged bytes are queued for deletion.',
  'imaging.deleteKeep': 'Keep',
  'imaging.deleteConfirm': 'Delete',
  'imaging.deleting': 'Deleting…',
  'imaging.deleteFailed': 'The deletion could not be completed. Nothing beyond the studies already removed was deleted.',

  'imaging.compatibility.pending': 'Compatibility check pending',
  'imaging.compatibility.supported': 'Supported',
  'imaging.compatibility.warning': 'Supported with warning',
  'imaging.compatibility.unsupported': 'Not supported',
  'imaging.issue.unsupportedModality': 'Objects with unsupported scan types were skipped.',
  'imaging.issue.unsupportedSopClass': 'Unsupported DICOM object types were skipped.',
  'imaging.issue.unsupportedTransferSyntax': 'Images with unsupported encoding were skipped.',
  'imaging.issue.unsupportedMultiframe': 'Unsupported multiframe objects were skipped.',
  'imaging.issue.nonDicomFilesIgnored': 'Non-DICOM files were ignored.',
  'imaging.issue.encryptedArchiveUnsupported': 'Password-protected ZIP archives cannot be imported.',
  'imaging.issue.burnedInAnnotation': 'The images may contain patient text drawn into the pixels.',
  'imaging.issue.lossyCompression': 'The source contains lossy-compressed images.',
  'imaging.issue.demographicMismatch': 'The source patient details differ from the selected patient.',
  'imaging.issue.other': 'The validator reported a compatibility warning.',
  // How many objects an issue covers. The count used to be a parenthesis
  // appended in TSX, which put a Latin bracket after a Hebrew sentence and
  // left the bidi algorithm to decide where it belonged.
  'imaging.issueWithCount': '{issue} ({count})',
  'imaging.failure.remoteNotImportable': 'This link opens a web viewer but does not expose a downloadable imaging package.',
  'imaging.failure.remoteForbidden': 'The link destination is not allowed for secure remote import.',
  'imaging.failure.remoteUnavailable': 'The remote source remained unavailable after repeated attempts. Check the link and source availability, then start the import again.',
  'imaging.failure.unsafeArchive': 'The archive was refused because its structure or expanded size is unsafe.',
  'imaging.failure.encryptedArchiveUnsupported': 'Password-protected ZIP archives cannot be imported. Remove the password and try again.',
  'imaging.failure.noDicom': 'No readable DICOM study was found in the supplied source.',
  'imaging.failure.mixedIdentity': 'The source contains more than one patient identity and cannot be imported together.',
  'imaging.failure.unsupportedDicom': 'The selected study is outside the supported DICOM compatibility contract.',
  'imaging.failure.duplicateImages': 'The source contains duplicate image identifiers.',
  'imaging.failure.inconsistentSeries': 'The source contains inconsistent series metadata and cannot be imported safely.',
  'imaging.failure.tooLarge': 'The source exceeds the configured imaging import limits.',
  'imaging.failure.generic': 'The imaging source could not be imported. Try again or ask an administrator to inspect the service.',
} as const
